import { useTranslation } from "react-i18next";

export default function ProgressStatus() {
  const { t } = useTranslation();
  return (
    <div className="bg-general-yellow-900 flex items-center justify-center h-10 text-sm font-medium fixed top-16 z-10 shrink-0 w-full">
      {t("progressStatus.sessionInProgress")}
    </div>
  );
}
